import {combineReducers} from 'redux'
import types from 'actions/types'

export const oneDriveStatus = (state = null, action) => {
  switch (action.type) {
    case types.ONE_DRIVE_DISABLE_SUCCESS:
      return action.data
    case types.ONE_DRIVE_STATUS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export default combineReducers({
  oneDriveStatus,
})
